import { StaticJsonRpcProvider, Web3Provider } from '@ethersproject/providers'
import { VESISConfig } from '~/types/config'
import { VotingEscrow, VotingEscrow__factory } from './types'

export function getVotingEscrowContract(
	config: VESISConfig,
	provider: Web3Provider | StaticJsonRpcProvider
): VotingEscrow {
	return VotingEscrow__factory.connect(config.votingEscrowAddress, provider)
}
